// Apolo IDE — keyboard helpers compartilhados.
//
// Centraliza duas coisas repetidas por vários atalhos:
//   1. isTypingTarget — não disparar atalho quando o foco está num campo
//      de texto (input/textarea/contenteditable).
//   2. modKey — rótulo do modificador por plataforma (⌘ no Mac, Ctrl+ no
//      resto), pra hints de teclado não ficarem Mac-only.

/**
 * True quando o elemento alvo é um campo de digitação — usado pra ignorar
 * atalhos globais enquanto o usuário escreve.
 * @param {EventTarget|null} target
 * @returns {boolean}
 */
export function isTypingTarget(target) {
  if (!target) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable === true;
}

// Detecta Mac uma vez (navigator é estável durante a sessão).
const IS_MAC = typeof navigator !== 'undefined'
  && /mac/i.test(navigator.platform || navigator.userAgent || '');

/**
 * Rótulo do modificador pra hints de teclado: '⌘' no Mac, 'Ctrl+' caso
 * contrário. Ex.: `${modKey()}E` → "⌘E" (Mac) ou "Ctrl+E" (Win/Linux).
 * @returns {string}
 */
export function modKey() {
  return IS_MAC ? '⌘' : 'Ctrl+';
}
